import React from 'react'
import './PaymentRedioGroup.css'

export const PaymentRedioGroup = ({children}) => {
    return (
        <div className='redio-checkbox'>
            {children}
        </div>
    )
}
